import { Dispatch, SetStateAction } from 'react';

import { CountryEntity } from 'api/types/entity';
import { SelectFilter } from 'components/Filters/SelectFilter';

export interface CountryFilterProps {
  title: string;
  countries: CountryEntity[];
  selectedCountries: string[];
  setSelectedCountries: Dispatch<SetStateAction<string[]>>;
}

export const CountryFilter = ({
  countries,
  title,
  selectedCountries,
  setSelectedCountries,
}: CountryFilterProps) => {
  const items = countries.map((v) => ({
    label: v.name,
    value: v.id,
  }));

  return (
    <SelectFilter
      enabledSearch
      activeValues={selectedCountries}
      options={items}
      title={title}
      onChange={setSelectedCountries}
    />
  );
};
